import BackofficeSidebar from './BackofficeSidebar';

export default BackofficeSidebar;
